// FORMATO DEGLI IMPORTI IN PARTITA
//
// Il punteggio e' in SOL, e i SOL sono numeri piccoli: la posta del tier 1 e'
// 0,005 e ogni pallina vale 0,0005. Con il vecchio formato — `$` e una sola
// cifra decimale — la HUD avrebbe mostrato "0.0" a tutti per l'intera partita.
//
// Qui si stampano abbastanza decimali da distinguere una pallina, togliendo gli
// zeri finali per non riempire la classifica di cifre inutili:
//
//   0.005   → "0.005"
//   0.0075  → "0.0075"
//   0.1     → "0.1"
//   1.23456 → "1.2346"

const DECIMALI_MAX = 4;

export function formatSol(valore) {
  const n = Number(valore) || 0;
  // `parseFloat` toglie gli zeri finali: 0.1000 diventa 0.1.
  return String(parseFloat(n.toFixed(DECIMALI_MAX)));
}

// Con il simbolo, per le etichette. '◎' e' il glifo convenzionale del SOL:
// occupa un carattere, che nella classifica e sopra i serpenti conta.
export function formatSolLabel(valore) {
  return `◎${formatSol(valore)}`;
}
